<template>
  <div class="top_bar">
    <ul class="top_list clearfix">
      <li class="fl logo_box">LOGO</li>
      <li class="fr"><a href="#" style="font-size: 16px" @click.prevent="logOut">退出</a></li>
      <li class="fr adress">{{company_name}}</li>
    </ul>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    name:'navHeader',
    data(){
      return{
        company_name:''
      }
    },
    mounted:function(){
      this.getCompanyName();
    },
    methods:{
      logOut:function(){
        axios.post('/login/logout',qs.stringify(
          {}
        )).then((response)=>{
          console.log(response);
          if(response.data.code==22000){
            window.location.href='/#/login';
          }else{

          }
        })
      },
      getCompanyName:function(){
        axios.get('/admin/getInfo',{

        }).then((response)=>{
          if(response.data.code==22000){
            this.company_name=response.data.result.company_id==0?'滨江区':response.data.result.company_name
          }
        })
      }
    }
  }
</script>
<style lang="less">
  .top_bar{
    position: fixed;
    top: 0px;
    right: 0px;
    left: 0px;
    z-index: 999;
    background: #fff;
    box-shadow: 0px 1px 5px rgba(185,186,194,0.5);
    padding:20px;
  }
  .fs14{
    font-size: 14px!important;
  }
  .top_list{
    li{
      font-size:16px;
      input{
        border-width: 1px;
        border-style: solid;
        border-color: #e1e7f6;
        height: 28px;
        margin-right: 20px;
        padding-left: 5px;
      }
    }
    .adress{
      margin-right: 30px;
    }
    .logo_box{
      width:200px;
      height: 28px;
      line-height: 28px;
      border:1px solid #e1e7f6;
      margin-right: 20px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue